var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcUserUnban = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14 6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m2 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0M5 20c0-1.947.71-3.422 1.803-4.417C7.91 14.577 9.475 14 11.273 14c.862 0 1.673.133 2.404.383a1 1 0 0 0 .646-1.893 9.4 9.4 0 0 0-3.05-.49c-2.22 0-4.29.714-5.816 2.104C3.92 15.504 3 17.529 3 20a1 1 0 1 0 2 0",
  clipRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 5,
  x: 16,
  y: 16,
  rx: 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.446 13.754c-.18 0-.34.107-.476.271a1.02 1.02 0 0 0-.22.642V16a.75.75 0 0 1-1.5 0v-1.332c.01-.374.138-1.216.561-1.595.369-.448.89-.746 1.47-.81a2.17 2.17 0 0 1 1.605.479c.45.364.746.886.852 1.456a.75.75 0 1 1-1.476.272c-.047-.445-.442-.716-.816-.716"
})));
export default SvgIcUserUnban;